import AnalyticsEngineBase from "../../../../src/common/analytics/analyticsenginebase";
import { insertGAScriptTag } from "../../../../src/common/utilities/DOMUtils";
import * as eventNames from "../../../../src/common/analytics/analyticsevents";

const moment = require("moment");
export default class AnalyticsEngineGA extends AnalyticsEngineBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
    this._options = options;
    let isEnabled = false;
    if (analyticsManager.cmpManager) {
      isEnabled = analyticsManager.cmpManager.isGATrackingEnabled();
      analyticsManager.cmpManager.on("userConsent:changed", () => {
        isEnabled = analyticsManager.cmpManager.isGATrackingEnabled();
        this.setTracking(isEnabled);
      });
    }
    insertGAScriptTag(options.gaTag, isEnabled);
    this._subscribeToEvents();
  }
  _subscribeToEvents() {
    this._analyticsManagerBase.on(eventNames.VIEW_PAGE, (data) => {
      this._reader(data);
    });
    this._analyticsManagerBase.on(
      eventNames.VIEW_PAGE_IN_BACKGROUND,
      (data) => {
        this._reader(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.VIEW_ARTICLE_ALB, (data) => {
      this._alb(data);
    });
    this._analyticsManagerBase.on(eventNames.OPENED_HOME, (data) => {
      this._setPageViewPageTracker("/index.html");
      this._sendScreenEvent(data, "Home");
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_SETTINGS_SIDEBAR,
      (data) => {
        this._sendScreenEvent(data, "Einstellungen");
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_SETTINGS, (data) => {
      this._sendScreenEvent(data, "Einstellungen");
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_FACEBOOK_SHARE, (data) => {
      this._sendSharingEvent(data, "Facebook");
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_WHATSAPP_SHARE, (data) => {
      this._sendSharingEvent(data, "Whatsapp");
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_TWITTER_X_SHARE,
      (data) => {
        this._sendSharingEvent(data, "Twitter");
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_MAIL_SHARE, (data) => {
      this._sendSharingEvent(data, "Mail");
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_PRINT_ALB, (data) => {
      this._sendSharingEvent(data, "Print");
    });
  }

  _reader(data) {
    const { bundle } = data.eventData;
    const { bundleDateTime, editionName, publication } = bundle;
    const dateFormatted = moment(bundleDateTime).format("YYYYMMDD");
    const { format, type, pages, publicationName } = publication;
    const pageStructure = this._createPagePageStructure(data);

    let jsonObject = {
      Date: dateFormatted,
      EditionName: "inSüdthüringen - " + publicationName,
      RegionName: editionName,
      PublicationTitleFormat: format,
      PublicationType: type,
      SubscriptionReference: data.user.subscriptionReference,
    };
    for (let i = 0; i < pages.length; i++) {
      jsonObject.PageReference = pages[i].pageReference;
      this._setPageViewPageTracker(pageStructure[i]);
      this._sendEventToGA(jsonObject, "Pageview");
    }
  }

  _alb(data) {
    const { bundle } = data.eventData;
    const { bundleDateTime, editionName, publication } = bundle;
    const dateFormatted = moment(bundleDateTime).format("YYYYMMDD");
    const { format, type, pages, publicationName } = publication;
    const jsonObject = {
      Date: dateFormatted,
      EditionName: "inSüdthüringen - " + publicationName,
      RegionName: editionName,
      PublicationTitleFormat: format,
      PublicationType: type,
      SubscriptionReference: data.user.subscriptionReference,
      PageReference: pages[0].pageReference,
      ArticleTitle: pages[0].articles[0].title,
      ArticleReference: pages[0].articles[0].articleReference,
    };
    const pageStructure = this._createArticlePageStructure(data);
    this._setPageViewPageTracker(pageStructure);
    this._sendEventToGA(jsonObject, "Articleview");
  }

  _sendScreenEvent(data, screenName) {
    const currentDate = Date.now();
    const dateFormatted = moment(currentDate).format("YYYYMMDD");
    const eventName = "ScreenView";
    const SubscriptionReference = data.user
      ? data.user.subscriptionReference
      : null;
    const jsonObject = {
      Date: dateFormatted,
      SubscriptionReference,
      ScreenName: screenName,
    };
    this._sendEventToGA(jsonObject, eventName);
  }

  _sendSharingEvent(data, targetName) {
    const { bundle } = data.eventData;
    const { bundleDateTime, editionName, publication } = bundle;
    const { format, type, pages, publicationName } = publication;
    const dateFormatted = moment(bundleDateTime).format("YYYYMMDD");
    const eventName = "ArticleShare";
    const jsonObject = {
      Date: dateFormatted,
      EditionName: "inSüdthüringen - " + publicationName,
      RegionName: editionName,
      PublicationTitleFormat: format,
      PublicationType: type,
      SubscriptionReference: data.user.subscriptionReference,
      PageReference: pages[0].pageReference,
      ArticleTitle: pages[0].articles[0].title,
      ArticleReference: pages[0].articles[0].articleReference,
      ClickTarget: targetName,
    };
    this._sendEventToGA(jsonObject, eventName);
  }

  _sendEventToGA(jsonObject, eventName) {
    if (!jsonObject || Object.keys(jsonObject).length === 0) {
      window.ga("send", eventName);
    } else {
      window.ga("send", eventName, jsonObject);
    }
  }

  _createBasicPageStructure(data) {
    const {
      eventData: { bundle },
    } = data;
    return `${bundle.downloadToken}/${bundle.bundleDateTime}/${bundle.publication.format}`;
  }

  _createPagePageStructure(data) {
    const pageStructures = [];
    const basicPageStructure = this._createBasicPageStructure(data);
    if (data && data.eventData && data.eventData.bundle) {
      data.eventData.bundle.publication.pages.forEach((page) => {
        if (page) {
          const pageReference = page.pageReference || page.pagePosition;
          var fullPageStructure = `${basicPageStructure}/${pageReference}`;
          if (
            data.deviceContext &&
            data.deviceContext.appContext &&
            data.deviceContext.appContext.socialSharing
          ) {
            fullPageStructure = fullPageStructure + "/SocialSharing";
          }
          pageStructures.push(fullPageStructure);
        }
      });
    }
    return pageStructures;
  }

  _createArticlePageStructure(data) {
    const basicPageStructure = this._createBasicPageStructure(data);
    var result = `${basicPageStructure}/${data.eventData.bundle.publication.pages[0].pageReference}/${data.eventData.bundle.publication.pages[0].articles[0].articleReference}`;
    if (
      data.deviceContext &&
      data.deviceContext.appContext &&
      data.deviceContext.appContext.socialSharing
    ) {
      result = result + "/SocialSharing";
    }
    return result;
  }
  _setPageViewPageTracker(pageStructure) {
    window.ga((tracker) => {
      // update the tracker if the page has changed
      if (pageStructure !== tracker.get("page")) {
        window.ga("set", "page", pageStructure);
      }
    });
  }

  setTracking(isTrackingEnable) {
    window[`ga-disable-${this._options.gaTag}`] = !isTrackingEnable;
  }
}



// WEBPACK FOOTER //
// ./clients/swmh-ist/js/engines/analyticsEngineGA.js